<template>
  <div :class="layoutClass">
    <div
      id="content-container"
      :class="{ 'show-banner': showBanner && projectLayout, framed: isFramed }"
    >
      <left-nav v-if="projectLayout" />
      <router-view :key="key"></router-view>
      <create-campaign-dialog
        :dialog-visible.sync="dialogVisible"
        :is-template-campaign="isTemplate"
      />
    </div>
  </div>
</template>

<script>
import CreateCampaignDialog from '@/modules/campaign-manage/components/CreateCampaignDialog'
import { EventBus } from '@/core/EventBus'
export default {
  name: 'Layout',
  components: { CreateCampaignDialog },
  data() {
    return {
      key: '',
      dialogVisible: false,
      isTemplate: false
    }
  },
  mounted() {
    EventBus.$on('show-campaign-create-dialog', async () => {
      // @TODO: Remove 'if' after Campaign create release
      if (!this.$store.state.app.features.campaignLegacyUI) {
        await this.$store.dispatch('reloadProjectConfig')
        this.dialogVisible = true
        this.isTemplate = false
      }
    })
    EventBus.$on('show-campaign-template-create-dialog', async () => {
      // @TODO: Remove 'if' after Campaign create release
      if (!this.$store.state.app.features.campaignLegacyUI) {
        await this.$store.dispatch('reloadProjectConfig')
        this.dialogVisible = true
        this.isTemplate = true
      }
    })
  },
  computed: {
    projectLayout() {
      return !!this.$store.getters.projectId && this.$route.name !== 'Home'
    },

    layoutClass() {
      if (this.$store.getters.projectId) {
        return 'layout-project'
      } else {
        return 'layout-basic'
      }
    },

    showBanner() {
      return this.$store.getters.isProjectNotActive
    },
    isFramed() {
      return window.top !== window.self
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/common/components/Layout.vue